import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { checkboxConfig, tokens } from '../../constants';
import { checkIsPlatform, getCurrentEventControlState } from '../../utils';
var getContainerBasicStyle = props => {
  var _props$labelPosition = props.labelPosition,
    labelPosition = _props$labelPosition === void 0 ? 'right' : _props$labelPosition,
    _props$checkboxVersio = props.checkboxVersion,
    checkboxVersion = _props$checkboxVersio === void 0 ? 'full-width' : _props$checkboxVersio;
  return Object.assign(Object.assign({}, checkboxVersion === 'fixed-width' && checkIsPlatform('web') ? {
    width: 'fit-content'
  } : {
    alignSelf: 'flex-start'
  }), {
    flexDirection: labelPosition === 'right' ? 'row' : 'row-reverse'
  });
};
var getIconContainerStyle = (props, controlState) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j;
  var bgColor = props === null || props === void 0 ? void 0 : props.checkboxBgColor;
  var labelPosition = props === null || props === void 0 ? void 0 : props.labelPosition;
  var configProps = props.config;
  var checked = props === null || props === void 0 ? void 0 : props.checked;
  var borderColor = props === null || props === void 0 ? void 0 : props.checkboxBorderColor;
  var checkedStyle = (_c = (_b = (_a = configProps === null || configProps === void 0 ? void 0 : configProps.state) === null || _a === void 0 ? void 0 : _a.checked) === null || _b === void 0 ? void 0 : _b.controlState) === null || _c === void 0 ? void 0 : _c[controlState];
  var uncheckedStyle = (_f = (_e = (_d = configProps === null || configProps === void 0 ? void 0 : configProps.state) === null || _d === void 0 ? void 0 : _d.unchecked) === null || _e === void 0 ? void 0 : _e.controlState) === null || _f === void 0 ? void 0 : _f[controlState];
  var checkboxSize = (_h = (_g = configProps === null || configProps === void 0 ? void 0 : configProps.size) === null || _g === void 0 ? void 0 : _g[props.size]) === null || _h === void 0 ? void 0 : _h.checkboxSize;
  var spacing = (_j = tokens.spacing) === null || _j === void 0 ? void 0 : _j[props === null || props === void 0 ? void 0 : props.spacing];
  var hasLabelOrDesc = (props === null || props === void 0 ? void 0 : props.label) || (props === null || props === void 0 ? void 0 : props.description) || (props === null || props === void 0 ? void 0 : props.multiTextLabel);
  var checkBoxBgColor = bgColor || (checked ? checkedStyle.backgroundColor : uncheckedStyle.backgroundColor);
  var checkboxBorderColor = borderColor || (checked ? checkedStyle.borderColor : uncheckedStyle.borderColor);
  return Object.assign(Object.assign(Object.assign(Object.assign({}, checked && checkedStyle), !checked && uncheckedStyle), {
    backgroundColor: checkBoxBgColor,
    borderColor: checkboxBorderColor,
    width: checkboxSize,
    height: checkboxSize,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: checkboxSize / 5
  }), hasLabelOrDesc && Object.assign({}, labelPosition == 'right' ? {
    marginRight: spacing
  } : {
    marginLeft: spacing
  }));
};
export var getCheckboxTextProps = (event, props) => {
  var _a, _b, _c, _d, _e;
  var checked = props.checked,
    controlState = props.controlState,
    config = props.config,
    size = props.size,
    isBoldLabel = props.isBoldLabel;
  var _controlState = getCurrentEventControlState(event, controlState);
  var configSize = config === null || config === void 0 ? void 0 : config.size;
  var labelFontType = (_a = configSize === null || configSize === void 0 ? void 0 : configSize[size]) === null || _a === void 0 ? void 0 : _a.labelFontType;
  var controlStateType = checked ? 'checked' : 'unchecked';
  var controlStateConfig = (_d = (_c = (_b = config === null || config === void 0 ? void 0 : config.state) === null || _b === void 0 ? void 0 : _b[controlStateType]) === null || _c === void 0 ? void 0 : _c.controlState) === null || _d === void 0 ? void 0 : _d[_controlState];
  if (isBoldLabel) labelFontType += '-bold';
  return {
    labelFontType,
    labelColor: controlStateConfig === null || controlStateConfig === void 0 ? void 0 : controlStateConfig.labelColor,
    descriptionFontType: (_e = configSize === null || configSize === void 0 ? void 0 : configSize[size]) === null || _e === void 0 ? void 0 : _e.descriptionFontType,
    descriptionColor: controlStateConfig === null || controlStateConfig === void 0 ? void 0 : controlStateConfig.descriptionColor
  };
};
export var getCheckboxStyles = (props, event) => {
  var _props$checkboxVersio2 = props.checkboxVersion,
    checkboxVersion = _props$checkboxVersio2 === void 0 ? 'full-width' : _props$checkboxVersio2;
  var controlState = getCurrentEventControlState(event, props === null || props === void 0 ? void 0 : props.controlState);
  return StyleSheet.create({
    container: getContainerBasicStyle(props),
    iconContainer: getIconContainerStyle(props, controlState),
    checkboxTextContainer: Object.assign({}, checkboxVersion === 'full-width' && {
      flex: 1
    }),
    checkboxTextAndLabel: {
      flexDirection: 'row',
      alignItems: 'center'
    },
    infoTagContainer: {
      marginLeft: tokens.spacing.SPACING_8
    },
    actionCta: {
      marginTop: tokens.spacing.SPACING_4
    }
  });
};
export var getCheckboxProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(checkboxConfig === null || checkboxConfig === void 0 ? void 0 : checkboxConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.checkbox) === null || _a === void 0 ? void 0 : _a[theme]);
  var controlState = (props === null || props === void 0 ? void 0 : props.disabled) && 'disabled' || (props === null || props === void 0 ? void 0 : props.controlState) || (configProps === null || configProps === void 0 ? void 0 : configProps.controlState);
  return Object.assign(Object.assign(Object.assign({
    theme
  }, configProps), props), {
    controlState
  });
};